import { setTasksVisualizationMetric as setTasksVisualizationMetricDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';

export type Props = ApiMethodBase & {
    metric?: Number,
}

export const setTasksVisualizationMetric = ({
    metric,
    eventEmitter,
}: Props) => {
    setTasksVisualizationMetricDiagram(metric);
};
